import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import DeleteIcon from '@material-ui/icons/Delete';
import { toKebabCase } from 'src/lib/FieldHelper';
import Row from '../UI/Row';

interface Props {
  onChange: (assetList: string[]) => void,
  ratio: number,
  assetList: string[],
}

const FundraisingSlider = ({
  onChange, ratio, assetList,
}: Props) => {
  const HEIGHT = 140;
  const getWidth = (height: number) => `${height * ratio}px`;

  const onDelete = (index: number) => {
    const newList = assetList.filter((_, current) => current !== index);
    onChange(newList);
  };

  const onDragEnd = (result: any) => {
    const { source, destination } = result;
    if (!destination) return;

    const newList = Array.from(assetList);
    const [removed] = newList.splice(source.index, 1);
    newList.splice(destination.index, 0, removed);

    onChange(newList);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable" direction="horizontal">
        {(provided: any) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            style={{
              width: '100%',
              display: 'flex',
              gap: '8px',
              overflowX: 'auto',
              height: `${HEIGHT}px`,
            }}>
            {assetList.map((asset, index) => (
              <Draggable
                key={toKebabCase(asset)}
                draggableId={toKebabCase(asset)}
                index={index}>
                {(providedDraggable: any) => (
                  <div
                    ref={providedDraggable.innerRef}
                    {...providedDraggable.draggableProps}
                    {...providedDraggable.dragHandleProps}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      flexShrink: 0,
                      flexGrow: 0,
                      border: '1px solid #c8c8c8',
                      borderRadius: '8px',
                      width: getWidth(HEIGHT),
                      height: `${HEIGHT}px`,
                      backgroundImage: `url(${asset}?${performance.now()})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                      ...providedDraggable.draggableProps.style,
                    }}>
                    <Row style={{ justifyContent: 'end', paddingRight: '8px' }} alignItems="center">
                      <div
                        style={{
                          width: 'fit-content',
                          height: '24px',
                          background: 'rgba(255, 255, 255, 0.75)',
                          borderRadius: '4px',
                          cursor: 'pointer',
                        }}
                        onClick={() => onDelete(index)}>
                        <DeleteIcon />
                      </div>
                    </Row>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default FundraisingSlider;
